import { useState, useRef } from "react";
import renderFileList from "./renderFileList";
import { Form, message, Modal, Spin } from "antd";
import useWebPost from "../utils/useWebPost";
import ImgUploader from "./ImgUploader";

function ViewModFiles({ rs, keys, table, onSave, canMod = false }) {
    const webPost = useWebPost();
    const [showModal, setShowModal] = useState(false);
    const [form] = Form.useForm();
    const uploadAttachMent = () => {
            console.log("1111111", table, onSave )
        if (canMod && (table || onSave)) {
            console.log("sfasdfsfd")
            form.setFieldValue('files', rs[keys]);
            setShowModal(true);
        }
    }
    const loadingRef = useRef();
    const [isloading, setIsloading] = useState(false);

    const saveAttachMent = async () => {
        if (loadingRef.current) return;
        setIsloading(true);
        loadingRef.current = true;
        try {
            const values = await form.validateFields();
            if(onSave){
                onSave(values.files);
                message.info('保存成功');
                rs[keys] = values.files;
                setShowModal(false);
                return;
            }
            const params = {
                id: rs.id, table, keys, v: values.files
            };
            const res = await webPost('saveAttachment', params);
            if (res) {
                message.info('保存成功');
                rs[keys] = values.files;
                setShowModal(false);
            } else {
                message.error('保存失败');
            }
        } finally {
            loadingRef.current = false;
            setIsloading(false);
        }
    }

    if (!rs || !keys) return null;
    return (<div onContextMenu={(e) => { e.preventDefault(); uploadAttachMent() }}>
        <Spin spinning={isloading}>
            {renderFileList(rs[keys])}
            <Modal title="上传文件" open={showModal} onCancel={() => setShowModal(false)} onOk={saveAttachMent}>
                <Form form={form}>
                    <Form.Item name='files' label="上传文件/图片"><ImgUploader /></Form.Item>
                </Form>
            </Modal>
        </Spin>
    </div>)
}
export default ViewModFiles;